module.exports = __webpack_public_path__ + "fonts/fa-brands-400.f4120760fb40152d1bdb109103063c13.woff2";